'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _tableLocal = require('./table.local.css');

var _tableLocal2 = _interopRequireDefault(_tableLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TableHeadCell = function TableHeadCell(_ref) {
  var field = _ref.field,
      sortColumn = _ref.sortColumn,
      label = _ref.label,
      setSort = _ref.setSort,
      sortable = _ref.sortable,
      className = _ref.className;

  var component = _react2.default.createElement('span', {
    className: _tableLocal2.default.headCellLabel
  }, label);

  if (sortable) {
    component = _react2.default.createElement('button', {
      className: (0, _classnames2.default)([_tableLocal2.default.headCellLabel, _tableLocal2.default.headCellButton]),
      onClick: setSort.bind(undefined, field)
    }, _react2.default.createElement('span', {
      className: (0, _classnames2.default)(_tableLocal2.default.label, _defineProperty({}, _tableLocal2.default.activeHeadCell, field === sortColumn.field))
    }, label), _react2.default.createElement(_icon2.default, {
      icon: 'caret',
      rotate: sortColumn.order === 'asc' ? 180 : 0,
      className: (0, _classnames2.default)([field === sortColumn.field && _tableLocal2.default.headCellButtonIconVisible, _tableLocal2.default.headCellButtonIcon])
    }));
  }

  return _react2.default.createElement('th', {
    className: (0, _classnames2.default)(_tableLocal2.default.headCell, className, field === sortColumn.field && _tableLocal2.default.activeHeadCell)
  }, component);
};

TableHeadCell.defaultProps = {
  sortable: false
};
TableHeadCell.propTypes = {
  // these are automatically attached
  // via the TableHead components re-rendering of it's children
  setSort: _propTypes2.default.func,
  sortColumn: _propTypes2.default.shape({
    field: _propTypes2.default.string.isRequired,
    order: _propTypes2.default.string.isRequired
  }),

  /**
   * Field this cell relates to
   */
  field: _propTypes2.default.string.isRequired,

  /**
   * Node to render as the label for the Header cell
   */
  label: _propTypes2.default.node.isRequired,

  /**
   * Is this column sortable?
   */
  sortable: _propTypes2.default.bool,

  /**
   * Classname to apply to the th node
   */
  className: _propTypes2.default.string
}; // Default these props in case this table is not meant to be sortable

TableHeadCell.defaultProps = {
  setSort: function setSort() {},
  sortColumn: {
    field: '',
    order: ''
  }
};
exports.default = TableHeadCell;